import { groupCartItems } from "../store/cartSlice";

const getPositiveInteger = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }
  return Math.floor(parsed);
};

const getVariantId = (product) => {
  return getPositiveInteger(product?.variant_id ?? product?.id);
};

export const buildCartCheckoutPayload = ({
  cartItems = [],
  address = "",
  customerFields = {},
}) => {
  const { bundles, standaloneItems } = groupCartItems(cartItems);
  const items = standaloneItems
    .map((item) => {
      const variantId = getVariantId(item?.product);
      const quantity = getPositiveInteger(item?.quantity || 1);
      if (!variantId || !quantity) {
        return null;
      }
      return {
        variant_id: variantId,
        quantity,
      };
    })
    .filter(Boolean);

  const checkoutBundles = bundles
    .map((bundle) => {
      const bundleId = getPositiveInteger(bundle?.id);
      const quantity = getPositiveInteger(
        bundle?.quantity ?? bundle?.items?.[0]?.quantity ?? 1,
      );
      const variantIds = [
        ...new Set(
          (bundle?.items || [])
            .map((item) => getVariantId(item?.product))
            .filter(Boolean),
        ),
      ];

      if (!bundleId || !quantity || !variantIds.length) return null;

      return {
        bundle_id: bundleId,
        quantity,
        variant_ids: variantIds,
      };
    })
    .filter(Boolean);

  return {
    items,
    bundles: checkoutBundles,
    address: String(address || "").trim(),
    ...customerFields,
  };
};
